import { Component, OnInit, NgZone, } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { Router } from '@angular/router';
declare const google: any;
declare module 'googlemaps';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css']
})
export class AddressComponent implements OnInit {
  form: FormGroup;
  addr = {};
  address = {}
  alternateAddress: FormArray
  communitySearch
  submitted = false
  errorMessage
  communityData
  currentUser
  addressName = ""

  addressNameObj = ""
  primaryAddressLoc: any = { lat: 0, lng: 0 };
  primaryAddress2Loc: any = { lat: 0, lng: 0 };
  secondaryAddressLoc: any = { lat: 0, lng: 0 };
  secondaryAddress2Loc: any = { lat: 0, lng: 0 };
  constructor(private fb: FormBuilder, private authService: AuthservicesService, private zone: NgZone, private router: Router) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('ministry_currentUser'))
    this.getCommunityId(this.currentUser)
    this.errorMessage = environment.errorMessage;

    this.form = this.fb.group({
      primaryAddress: ['', Validators.required],
      primaryAddress2: [''],
      secondaryAddress: [''],
      secondaryAddress2: ['']
    })
  }


  get f() {
    return this.form.controls;
  }

  getCommunityId(data) {
    let id
    if (data) {
      id = this.currentUser.id
    }
    this.authService.getCommunityByid(id).subscribe((res: any) => {
      this.communityData = res.data;
      this.fetchData();
    },
      error => {
        console.log(error)
      })
  }

  redirect() {
    this.router.navigate(['/user-registration/basic-info'])
  }

  fetchData() {
    if (this.communityData) {
      // Helper to safely extract address string
      const getAddr = (val: any) => {
        if (!val) return '';
        if (typeof val === 'string') return val;
        return val.address || val.googleAddress || val.streetAddress || '';
      };

      // Helper to safely extract coordinates
      const getCoords = (val: any) => {
        if (val?.coordinates && Array.isArray(val.coordinates)) {
          return { lat: val.coordinates[1], lng: val.coordinates[0] };
        }
        if (val?.location?.coordinates && Array.isArray(val.location.coordinates)) {
          return { lat: val.location.coordinates[1], lng: val.location.coordinates[0] };
        }
        return { lat: 0, lng: 0 };
      };

      this.form.patchValue({
        primaryAddress: getAddr(this.communityData.primaryAddress) || getAddr(this.communityData.address),
        primaryAddress2: getAddr(this.communityData.primaryAddress2),
        secondaryAddress: getAddr(this.communityData.secondaryAddress),
        secondaryAddress2: getAddr(this.communityData.secondaryAddress2)
      });

      // Restore coordinates
      this.primaryAddressLoc = getCoords(this.communityData.primaryAddress) || getCoords(this.communityData.address);
      this.primaryAddress2Loc = getCoords(this.communityData.primaryAddress2);
      this.secondaryAddressLoc = getCoords(this.communityData.secondaryAddress);
      this.secondaryAddress2Loc = getCoords(this.communityData.secondaryAddress2);
    }
  }

  onSubmit() {

    this.submitted = true;
    if (this.form.invalid) {
      this.authService.scrollToError();
      return;
    }
    let formObj = this.form.value;

    // Construct payload with GeoJSON objects
    const payload = {
      ...formObj,
      primaryAddress: {
        type: 'Point',
        coordinates: [this.primaryAddressLoc.lng, this.primaryAddressLoc.lat],
        address: this.form.value.primaryAddress || ''
      },
      primaryAddress2: {
        type: 'Point',
        coordinates: [this.primaryAddress2Loc.lng, this.primaryAddress2Loc.lat],
        address: this.form.value.primaryAddress2 || ''
      },
      secondaryAddress: {
        type: 'Point',
        coordinates: [this.secondaryAddressLoc.lng, this.secondaryAddressLoc.lat],
        address: this.form.value.secondaryAddress || ''
      },
      secondaryAddress2: {
        type: 'Point',
        coordinates: [this.secondaryAddress2Loc.lng, this.secondaryAddress2Loc.lat],
        address: this.form.value.secondaryAddress2 || ''
      }
    };

    this.authService.signUpAddress(payload).subscribe((res: any) => {
      console.log(res)

      this.authService.successMessage('Address has been Submitted', 'success')
      this.router.navigate(["/user-registration/social-links"]);

    },
      error => {
        if (error.error.code == '401') {
          this.authService.refreshToken();
        }
        this.authService.successMessage(error.error.message, 'error')
        console.log(error)
      })

  }

  AddressChange(address: any, arr?) {
    this.zone.run(() => {
      const lat = address.geometry.location.lat();
      const lng = address.geometry.location.lng();
      const formatted = address.formatted_address || address.name || '';

      if (arr === 'primaryAddress2') {
        this.form.get('primaryAddress2').setValue(formatted);
        this.primaryAddress2Loc = { lat, lng };
      } else if (arr === 'secondaryAddress') {
        this.form.get('secondaryAddress').setValue(formatted);
        this.secondaryAddressLoc = { lat, lng };
      } else if (arr === 'secondaryAddress2') {
        this.form.get('secondaryAddress2').setValue(formatted);
        this.secondaryAddress2Loc = { lat, lng };
      } else {
        // Default to primaryAddress
        this.form.get('primaryAddress').setValue(formatted);
        this.primaryAddressLoc = { lat, lng };
      }
    })
  }
}
